import {
   Box,
   Grid,
   List,
   ListItem,
   ListItemText,
   TextField,
   Typography,
} from "@mui/material";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { sizes } from "../../setupUtils";
import { useState } from "react";
import dayjs from "dayjs";
import { setCGState } from "../customerGroupSetupSlice";
import { useEffect } from "react";

export default function CreateEditIndividualCustomerDate() {
   const cgState = useSelector((store) => store.customerGroupSetup);
   const { selCustomers, createFromDate, createToDate } = cgState;
   const dispatch = useDispatch();

   const minDate = dayjs().add(1, "day");

   useEffect(() => {
      setDefaultDate();
   }, []);

   function setDefaultDate() {
      const updatedCustomers = selCustomers.map((item) => {
         if (
            item.hasOwnProperty("effectiveStartDate") &&
            item.hasOwnProperty("effectiveEndDate")
         ) {
            return item;
         }
         return {
            ...item,
            effectiveStartDate: createFromDate,
            effectiveEndDate: createToDate,
         };
      });
      dispatch(setCGState("selCustomers", updatedCustomers));
   }

   function updateFromDate(newDate, customerName) {
      let updatedCustomers = selCustomers.map((customer) => {
         if (customer.customerName === customerName) {
            return {
               ...customer,
               effectiveStartDate: newDate,
               effectiveEndDate: customer.effectiveEndDate,
            };
         }
         return customer;
      });
      dispatch(setCGState("selCustomers", updatedCustomers));
      dispatch(setCGState("createIndDateUpdated", true));
   }

   function updateToDate(newDate, customerName) {
      let updatedCustomers = selCustomers.map((customer) => {
         if (customer.customerName === customerName) {
            return {
               ...customer,
               effectiveStartDate: customer.effectiveStartDate,
               effectiveEndDate: newDate,
            };
         }
         return customer;
      });
      dispatch(setCGState("selCustomers", updatedCustomers));
      dispatch(setCGState("createIndDateUpdated", true));
   }

   function handleFromDate(newDate) {}
   return (
      <Box sx={{ mt: 4 }}>
         <Box
            sx={{
               bgcolor: "blue.light",
               height: 40,
               pl: 1,
               pt: 1,
               borderRadius: 1,
            }}
         >
            <Typography sx={{ fontWeight: "bold" }}>Customers</Typography>
         </Box>
         <Box
            sx={{
               height: 360,
               overflow: "auto",
            }}
         >
            {selCustomers.map((customer, index) => {
               return (
                  <Grid container columnSpacing={1} sx={{ mt: 1 }} key={index}>
                     <Grid item xs={8}>
                        <Typography variant="p16w400">
                           {customer.customerName}
                        </Typography>
                     </Grid>

                     <Grid item xs={2}>
                        <Box>
                           <LocalizationProvider dateAdapter={AdapterDayjs}>
                              <DatePicker
                                 minDate={minDate}
                                 label="From"
                                 value={customer.effectiveStartDate}
                                 onChange={(newDate) =>
                                    updateFromDate(
                                       newDate,
                                       customer.customerName
                                    )
                                 }
                                 renderInput={(params) => (
                                    <TextField
                                       {...params}
                                       size="small"
                                       sx={{ width: sizes.w150 }}
                                    />
                                 )}
                                 format="DD/MM/YYYY"
                              />
                           </LocalizationProvider>
                        </Box>
                     </Grid>

                     <Grid item xs={2}>
                        <Box sx={{ mr: 0.5 }}>
                           <LocalizationProvider dateAdapter={AdapterDayjs}>
                              <DatePicker
                                 minDate={minDate}
                                 label="To"
                                 value={customer.effectiveEndDate}
                                 onChange={(newDate) =>
                                    updateToDate(newDate, customer.customerName)
                                 }
                                 renderInput={(params) => (
                                    <TextField
                                       {...params}
                                       size="small"
                                       sx={{ width: sizes.w150 }}
                                    />
                                 )}
                                 format="DD/MM/YYYY"
                              />
                           </LocalizationProvider>
                        </Box>
                     </Grid>
                  </Grid>
               );
            })}
         </Box>
      </Box>
   );
}
